import { render, staticRenderFns } from "./cuestionario.vue?vue&type=template&id=4041f1c1&"
import script from "./cuestionario.vue?vue&type=script&lang=js&"
export * from "./cuestionario.vue?vue&type=script&lang=js&"
import style0 from "./cuestionario.vue?vue&type=style&index=0&id=4041f1c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports